import type { ListBuilderConfiguration } from '../types';

/**
 * Email Templates list configuration
 * Converted from JSON to TypeScript for type safety
 */
export const EMAIL_TEMPLATES_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-email-templates',
			cacheTTL: 600000,
			name: 'All Email Templates',
			type: 'default',
			active: true,
			columns: [
				{
					id: 'template-name',
					headers: [
						{
							id: 'template-name-header',
							text: 'Template',
						},
					],
					fields: [
						{
							id: 'name-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'name',
									objectTable: 'email_template',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
							link: {
								type: 'object',
								enabled: true,
							},
						},
						{
							id: 'line-break-1',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							displayStyle: 'line_break',
						},
						{
							id: 'description-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'description',
									objectTable: 'email_template',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'muted',
								},
							},
							displayStyle: 'text',
						},
					],
					sortable: true,
				},
				{
					id: 'status',
					headers: [
						{
							id: 'status-header',
							text: 'Status',
						},
					],
					fields: [
						{
							id: 'status-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'isActive',
									objectTable: 'email_template',
								},
							},
							styleConfig: {
								size: 'sm',
								valueMapping: [
									{
										value: true,
										label: 'Active',
										color: { type: 'success' },
									},
									{
										value: false,
										label: 'Inactive',
										color: { type: 'neutral' },
									},
								],
							},
							displayStyle: 'badge',
						},
					],
					sortable: true,
					width: 100,
				},
				{
					id: 'variables',
					headers: [
						{
							id: 'variables-header',
							text: 'Variables',
						},
					],
					fields: [
						{
							id: 'variables-count-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'variableCount',
									objectTable: 'email_template',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
							suffix: ' variables',
						},
						{
							id: 'line-break-vars',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							displayStyle: 'line_break',
						},
						{
							id: 'required-count-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'requiredVariableCount',
									objectTable: 'email_template',
								},
							},
							styleConfig: {
								size: 'xs',
								colorRule: {
									type: 'muted',
								},
							},
							displayStyle: 'text',
							suffix: ' required',
							hideIfZero: true,
						},
					],
					width: 120,
				},
				{
					id: 'created-date',
					headers: [
						{
							id: 'created-date-header',
							text: 'Created',
						},
					],
					fields: [
						{
							id: 'created-date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'createdDate',
									objectTable: 'email_template',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'muted',
								},
							},
							displayStyle: 'date',
							formatOptions: {
								dateStyle: 'short',
							},
						},
					],
					sortable: true,
					width: 120,
				},
				{
					id: 'modified-date',
					headers: [
						{
							id: 'modified-date-header',
							text: 'Modified',
						},
					],
					fields: [
						{
							id: 'modified-date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'modifiedDate',
									objectTable: 'email_template',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'muted',
								},
							},
							displayStyle: 'date',
							formatOptions: {
								dateStyle: 'short',
							},
						},
					],
					sortable: true,
					width: 120,
				},
			],
			defaultSortId: 'template-name',
			sortOrder: 0,
		},
	],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [10, 20, 50, 100],
	},
	filters: {
		activeFilters: [
			'emailTemplateKeywords',
			'emailTemplateStatus',
			'emailTemplateCreatedDate',
		],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/settings/email-templates/:id/edit',
			objectLabel: 'Email Template',
			objectTable: 'email_template',
			selectedFields: [
				{
					fieldName: 'id',
					fieldLabel: 'ID',
				},
				{
					fieldName: 'name',
					fieldLabel: 'Name',
				},
				{
					fieldName: 'description',
					fieldLabel: 'Description',
				},
				{
					fieldName: 'isActive',
					fieldLabel: 'Status',
				},
				{
					fieldName: 'variableCount',
					fieldLabel: 'Variable Count',
				},
				{
					fieldName: 'requiredVariableCount',
					fieldLabel: 'Required Variables',
				},
				{
					fieldName: 'createdDate',
					fieldLabel: 'Created Date',
				},
				{
					fieldName: 'modifiedDate',
					fieldLabel: 'Modified Date',
				},
			],
		},
	],
};
